"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleAccountsStorage = void 0;
/**
 * @category AccountsStorage
 */
class SimpleAccountsStorage {
    /**
     * Creates new simple accounts storage.
     *
     * If no `defaultAccount` provided, uses first provided entry
     *
     * @param args
     */
    constructor(args = {}) {
        this.accounts = new Map();
        if (args.entries != null) {
            for (const account of args.entries) {
                if (this._defaultAccount == null) {
                    this._defaultAccount = account.address;
                }
                this.accounts.set(account.address, account);
            }
        }
        if (args.defaultAccount != null) {
            if (!this.accounts.has(args.defaultAccount)) {
                throw new Error('Provided default account not found in storage');
            }
            this._defaultAccount = args.defaultAccount;
        }
    }
    get defaultAccount() {
        return this._defaultAccount;
    }
    set defaultAccount(value) {
        if (value != null && !this.accounts.has(value)) {
            throw new Error('Account not found in storage');
        }
        this._defaultAccount = value;
    }
    async getAccount(address) {
        return this.accounts.get(address);
    }
    addAccount(account) {
        this.accounts.set(account.address, account);
    }
    hasAccount(address) {
        return this.accounts.has(address);
    }
    removeAccount(address) {
        this.accounts.delete(address);
    }
}
exports.SimpleAccountsStorage = SimpleAccountsStorage;
